import Layout from './components/layout';
import AssetDetailsDialogue from './components/AssetDetailsDialouge';

export default {
	Layout, AssetDetailsDialouge: AssetDetailsDialogue
}